import { useAtom } from 'jotai';
import { useHistory } from 'react-router-dom';
import { EvaluationForm } from './evaluation-form';
import { usePackageEvaluation } from './evaluation-result/atoms';

interface EvaluationFormVersionSwitcherProps {
  href: string;
  getEvaluations: () => Promise<void>;
}

/**
 * Data-fetching wrapper for EvaluationForm (Eval 2.0 new evaluation view).
 * Loads the packageEvaluation from the current URL and passes
 * partiallyCoveredWellsCount to EvaluationForm.
 *
 * @param {EvaluationFormVersionSwitcherProps} props - Component props.
 * @return {JSX.Element} The EvaluationForm component.
 */
export const EvaluationFormVersionSwitcher = ({
  href,
  getEvaluations,
}: EvaluationFormVersionSwitcherProps) => {
  const { location } = useHistory();
  const packageEvaluationAtom = usePackageEvaluation(
    `${location.pathname}${location.search}`
  );

  const [packageEvaluation] = useAtom(packageEvaluationAtom);

  return (
    <EvaluationForm
      href={href}
      getEvaluations={getEvaluations}
      partiallyCoveredWellsCount={
        packageEvaluation.data &&
        'partiallyCoveredWellsCount' in packageEvaluation.data
          ? packageEvaluation.data.partiallyCoveredWellsCount
          : undefined
      }
    />
  );
};
